import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { PowerSupplySfp } from '@psnb/psnb-api';
import { PowerSupplySfpTriage } from '@psnb/psnb-api';
import { PowerSupplyService } from '@psnb/services';
import { NumberOnlyValidation } from '../numberOnly.validation';
import { CommonService } from '../../../common/common.service';
import { PowerSupplyMoveErrorDialog } from 'desktop/power-supply/power-supply-move/power-supply-move-error-dialog';
import { UserDetails } from "@psnb/psnb-api";
import { ActivatedRoute,Router } from '@angular/router';
import { DatesharedService } from 'desktop/power-supply/power-supply-edit/dateshared.service';

@Component({
  selector: 'nwt-power-supply-edit-supplysfp',
  templateUrl: './power-supply-edit-supplysfp.html',
  styleUrls: ['./power-supply-edit-supplysfp.scss']
})
export class PowerSupplyEditSupplysfpComponent implements OnInit {
  public zoomLevel: number = 1;
  public userDetails: UserDetails;
  public scannerEnabled: any;
  public information: string = "";
  sfpsupplyFormGroup: FormGroup;
  supplyNumber: any;
  powerSupplyId: number = 0;
  id: number = 0;
  supplyName: string = '';
  sysContact: string = '';
  sysLocation; string = '';
  deviceIds: string[] = ['1', '2', '3', '4', '5', 'Not an Alpha Supply'];
  powerSupplyModels: string[] = [];
  eventLogs: string[] = ['Yes', 'No'];
  acInputVoltageRatings: string[] = ['120VAC', '210VAC', '240VAC'];
  acOutputVoltageRatings: string[] = ['60VAC', '75VAC', '90VAC'];
  currentAmpRatings: string[] = ['4.8Amp', '8Amp', '15Amp', '18Amp', '22Amp', '24Amp'];
  currentAmpOutputUses: string[] = ['Output#1', 'Output#2', 'DualOutput'];
  pimDocsInstalled: string[] = ['Yes', 'No'];
  alphaAPPCardsInstalled: string[] = ['Yes', 'No'];
  controllerCardTypes: string[] = [];
  dcReadys: string[] = ['Yes', 'No'];
  showProgressBar: boolean = false;
  telemetryThresholdProfileData : Array<string> = [];
  powerSupplyAlertProfile = '';
  ampRatings: any[] = [];
  scanSerialNum: string;
  scansfpmac: string;
  processedsfpMac:any;
  triageId:number;
  permissionValue:any;
  triageIDURL: any;
  createFlag: boolean;
  zoomFlag: any;
  private powerSupplyMoveErrorDialog: MatDialogRef<PowerSupplyMoveErrorDialog>;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private fb: FormBuilder,
    private sharedService : DatesharedService,
    private router: Router,
    private route: ActivatedRoute,
    private powerSupplyService: PowerSupplyService,
    private commonService: CommonService,
    public dialogRef: MatDialogRef<PowerSupplyEditSupplysfpComponent>,
    private ref: ChangeDetectorRef,
    private dialog: MatDialog,
  ) {
    this.triageId = this.data.triageId;
  }

  ngOnInit() {
    this.route.queryParams
    .subscribe(params => {
      if(params['nodeId'] === undefined){ //edit
        this.createFlag = false;
      }else{
        this.createFlag = true;
      }
      this.triageIDURL =params['triageId'];
    });
    this.showProgressBar = false;
    this.supplyNumber = this.data.supplyNumber;
    this.powerSupplyModels = this.data.powerSupplyModels;
    this.controllerCardTypes = this.data.controlCardTypes;
    this.powerSupplyId = this.data.id;
    this.supplyName = this.data.supplyName;
    this.sysContact = this.data.sysContact;
    this.sysLocation = this.data.sysLocation;
    this.ampRatings = this.data.ampRatings;
    this.permissionValue = this.data.permissionValue;
    this.sfpsupplyFormGroup = this.fb.group({
      bootfileversion: [''],
      hardwarerevision: [''],
      model: [''],
      serialNo: [''],
      sfpipv4: [''],
      sfpMac: ['', Validators.required],
      vendor: ['']
    });
    this.markAsTouched(this.sfpsupplyFormGroup);
    this.ref.detectChanges();
    if (this.permissionValue == false) { // non comcast user
      if (this.powerSupplyId != null && this.powerSupplyId != 0) {
        if(!this.triageIDURL || this.triageIDURL == undefined){
          //check response if null or not
          this.powerSupplyService.getPowerSupplySfpTriageByPsId(this.powerSupplyId,null).subscribe(res => {
            if (res && res.id != null) {
                this.id = res.id;
                this.sfpsupplyFormGroup.patchValue({
                  bootfileversion: res.bootFileVersion,
                  hardwarerevision: res.hardwareRevision,
                  model: res.model,
                  serialNo: res.serialNumber,
                  sfpipv4: res.sfpIpv4,
                  sfpMac: res.sfpMacAddress,
                  vendor: res.vendor
                });
                this.markAsTouched(this.sfpsupplyFormGroup);
                this.ref.detectChanges();
             }else{
               this.powerSupplyService.getPowerSupplySfpByPowerSupplyId(this.powerSupplyId).subscribe(res => {
                 if (res.id != 0 && res.id != null) {
                    this.id = res.id;
                    this.sfpsupplyFormGroup.patchValue({
                      bootfileversion: res.bootFileVersion,
                      hardwarerevision: res.hardwareRevision,
                      model: res.model,
                      serialNo: res.serialNumber,
                      sfpipv4: res.sfpIpv4,
                      sfpMac: res.sfpMacAddress,
                      vendor: res.vendor
                    });
                    this.markAsTouched(this.sfpsupplyFormGroup);
                    this.ref.detectChanges();
                 } else this.id = 0;
                 this.markAsTouched(this.sfpsupplyFormGroup);
                 this.ref.detectChanges();
                 this.showProgressBar = false;
               }, err => {
                 this.markAsTouched(this.sfpsupplyFormGroup);
                 this.ref.detectChanges();
                 this.showProgressBar = false;
               });
             }
           });
        }else{
          this.powerSupplyService.getPowerSupplySfpTriageByPsId(this.powerSupplyId,this.triageId).subscribe(res => {
            if (res && res.id != null) {
              //res.forEach(element => {
                this.id = res.id;
                this.sfpsupplyFormGroup.patchValue({
                  bootfileversion: res.bootFileVersion,
                  hardwarerevision: res.hardwareRevision,
                  model: res.model,
                  serialNo: res.serialNumber,
                  sfpipv4: res.sfpIpv4,
                  sfpMac: res.sfpMacAddress,
                  vendor: res.vendor
                });
              this.markAsTouched(this.sfpsupplyFormGroup);
              this.ref.detectChanges();
            }else if(res && res.id == null){
              //No change in SFP data by Bp user - but comcast user is having SFP data
              this.powerSupplyService.getPowerSupplySfpByPowerSupplyId(this.powerSupplyId).subscribe(res => {
                if (res.id != 0 && res.id != null) {
                    this.id = res.id;
                    this.sfpsupplyFormGroup.patchValue({
                      bootfileversion: res.bootFileVersion,
                      hardwarerevision: res.hardwareRevision,
                      model: res.model,
                      serialNo: res.serialNumber,
                      sfpipv4: res.sfpIpv4,
                      sfpMac: res.sfpMacAddress,
                      vendor: res.vendor
                    });
                  this.markAsTouched(this.sfpsupplyFormGroup);
                  this.ref.detectChanges();
                } else this.id = 0;
                this.markAsTouched(this.sfpsupplyFormGroup);
                this.ref.detectChanges();
                this.showProgressBar = false;
              }, err => {
                this.markAsTouched(this.sfpsupplyFormGroup);
                this.ref.detectChanges();
                this.showProgressBar = false;
              });
            } else this.id = 0;
            this.markAsTouched(this.sfpsupplyFormGroup);
            this.ref.detectChanges();
            this.showProgressBar = false;
          }, err => {
            this.markAsTouched(this.sfpsupplyFormGroup);
            this.ref.detectChanges();
            this.showProgressBar = false;
          });

        }

      }
       else this.showProgressBar = false;
    }else{
      if (this.powerSupplyId != null && this.powerSupplyId != 0) {
        this.powerSupplyService.getPowerSupplySfpByPowerSupplyId(this.powerSupplyId).subscribe(res => {
          if (res.id != 0 && res.id != null) {
              this.id = res.id;
              this.sfpsupplyFormGroup.patchValue({
                bootfileversion: res.bootFileVersion,
                hardwarerevision: res.hardwareRevision,
                model: res.model,
                serialNo: res.serialNumber,
                sfpipv4: res.sfpIpv4,
                sfpMac: res.sfpMacAddress,
                vendor: res.vendor
              });
              this.markAsTouched(this.sfpsupplyFormGroup);
              this.ref.detectChanges();
          } else this.id = 0;
          this.markAsTouched(this.sfpsupplyFormGroup);
          this.ref.detectChanges();
          this.showProgressBar = false;
        }, err => {
          this.markAsTouched(this.sfpsupplyFormGroup);
          this.ref.detectChanges();
          this.showProgressBar = false;
        });
      } else this.showProgressBar = false;
    }
  }


  saveSFPSupplyChanges() {
    this.showProgressBar = true;
    if(this.createFlag){
      //store in session for create page
      const jsonPowerSupplySfp: PowerSupplySfpTriage = {};
      jsonPowerSupplySfp.powerSupplyId = null;
      jsonPowerSupplySfp.triageId = null;
      jsonPowerSupplySfp.sfpMacAddress = this.sfpsupplyFormGroup.value.sfpMac;
      jsonPowerSupplySfp.vendor = this.sfpsupplyFormGroup.value.vendor;
      jsonPowerSupplySfp.vendor = this.sfpsupplyFormGroup.value.vendor;
      jsonPowerSupplySfp.model = this.sfpsupplyFormGroup.value.model;
      jsonPowerSupplySfp.serialNumber = this.sfpsupplyFormGroup.value.serialNo;
      jsonPowerSupplySfp.hardwareRevision = this.sfpsupplyFormGroup.value.hardwarerevision;
      jsonPowerSupplySfp.bootFileVersion = this.sfpsupplyFormGroup.value.bootfileversion;
      jsonPowerSupplySfp.sfpIpv4 = this.sfpsupplyFormGroup.value.sfpipv4;
      localStorage.removeItem('powerSupplySfp');
      localStorage.setItem('powerSupplySfp', JSON.stringify(jsonPowerSupplySfp));
      this.onChangeSfpMac(this.sfpsupplyFormGroup.value.sfpMac);
      this.dialogRef.close('CREATED');
    }else{
      //normal save
    if (this.permissionValue == true) {
      const jsonPowerSupplySfp: PowerSupplySfp = {};
      jsonPowerSupplySfp.powerSupplyId = this.powerSupplyId;
      jsonPowerSupplySfp.sfpMacAddress = this.sfpsupplyFormGroup.value.sfpMac;
      jsonPowerSupplySfp.vendor = this.sfpsupplyFormGroup.value.vendor;
      jsonPowerSupplySfp.vendor = this.sfpsupplyFormGroup.value.vendor;
      jsonPowerSupplySfp.model = this.sfpsupplyFormGroup.value.model;
      jsonPowerSupplySfp.serialNumber = this.sfpsupplyFormGroup.value.serialNo;
      jsonPowerSupplySfp.hardwareRevision = this.sfpsupplyFormGroup.value.hardwarerevision;
      jsonPowerSupplySfp.bootFileVersion = this.sfpsupplyFormGroup.value.bootfileversion;
      jsonPowerSupplySfp.sfpIpv4 = this.sfpsupplyFormGroup.value.sfpipv4;
      if (this.id == 0 || this.id == null) {
        this.powerSupplyService.createPowerSupplySfp(jsonPowerSupplySfp).subscribe(res => {
          this.showProgressBar = false;
          if (res.success === true) {
            this.onChangeSfpMac(this.sfpsupplyFormGroup.value.sfpMac);
            const activity = `PowerSupply Edit - Supply#${this.supplyNumber} Save`;
            const message = `PowerSupply Supply#${this.supplyNumber} Create Success. Data: ${JSON.stringify(jsonPowerSupplySfp)}`;
            this.commonService.loggerPost(message, activity, 3);
            this.dialogRef.close('CREATED');
          } else {
            const activity = `PowerSupply Edit - Supply#${this.supplyNumber} Save - Error`;
            const message = `PowerSupply Supply#${this.supplyNumber} Create Error. Data: ${JSON.stringify(jsonPowerSupplySfp)}`;
            this.commonService.loggerPost(message, activity, 3);
            this.dialogRef.close('FAILED');
          }
        },
          err => {
            const activity = `PowerSupply Edit - Supply#${this.supplyNumber} Save - Error`;
            const message = `PowerSupply Supply#${this.supplyNumber} Create Error. Data: ${JSON.stringify(jsonPowerSupplySfp)}`;
            this.commonService.loggerPost(message, activity, 3);
            this.dialogRef.close('FAILED');
            this.showProgressBar = false;
          });
      } else {
        jsonPowerSupplySfp.id = this.id;
        this.powerSupplyService.updatePowerSupplySfp(jsonPowerSupplySfp).subscribe(res => {
          this.showProgressBar = false;
          if (res.success === true) {
            this.onChangeSfpMac(this.sfpsupplyFormGroup.value.sfpMac);
            const activity = `PowerSupply Edit - Supply#${this.supplyNumber} Save`;
            const message = `PowerSupply Supply#${this.supplyNumber} Update Success. Data: ${JSON.stringify(jsonPowerSupplySfp)}`;
            this.commonService.loggerPost(message, activity, 3);
            this.dialogRef.close('UPDATED');
          } else {
            const activity = `PowerSupply Edit - Supply#${this.supplyNumber} Save - Error`;
            const message = `PowerSupply Supply#${this.supplyNumber} Update Error. Data: ${JSON.stringify(jsonPowerSupplySfp)}`;
            this.commonService.loggerPost(message, activity, 3);
            this.dialogRef.close('FAILED');
          }
        },
          err => {
            const activity = `PowerSupply Edit - Supply#${this.supplyNumber} Save - Error`;
            const message = `PowerSupply Supply#${this.supplyNumber} Update Error. Data: ${JSON.stringify(jsonPowerSupplySfp)}`;
            this.commonService.loggerPost(message, activity, 3);
            this.dialogRef.close('FAILED');
            this.showProgressBar = false;
          });
      }
    }else{
      const jsonPowerSupplySfpTriage: PowerSupplySfpTriage = {};
      jsonPowerSupplySfpTriage.powerSupplyId = this.powerSupplyId;
      jsonPowerSupplySfpTriage.triageId = this.triageId;
      jsonPowerSupplySfpTriage.sfpMacAddress = this.sfpsupplyFormGroup.value.sfpMac;
      jsonPowerSupplySfpTriage.vendor = this.sfpsupplyFormGroup.value.vendor;
      jsonPowerSupplySfpTriage.model = this.sfpsupplyFormGroup.value.model;
      jsonPowerSupplySfpTriage.serialNumber = this.sfpsupplyFormGroup.value.serialNo;
      jsonPowerSupplySfpTriage.hardwareRevision = this.sfpsupplyFormGroup.value.hardwarerevision;
      jsonPowerSupplySfpTriage.bootFileVersion = this.sfpsupplyFormGroup.value.bootfileversion;
      jsonPowerSupplySfpTriage.sfpIpv4 = this.sfpsupplyFormGroup.value.sfpipv4;
      if (this.id == 0 || this.id == null) {
        this.powerSupplyService.savePowerSupplySfpTriage(jsonPowerSupplySfpTriage).subscribe(res => {
          this.showProgressBar = false;
          if (res.success === true) {
            this.onChangeSfpMac(this.sfpsupplyFormGroup.value.sfpMac);
            const activity = `PowerSupply Edit - Supply#${this.supplyNumber} Save`;
            const message = `PowerSupply Supply#${this.supplyNumber} Create Success. Data: ${JSON.stringify(jsonPowerSupplySfpTriage)}`;
            this.commonService.loggerPost(message, activity, 3);
            this.dialogRef.close('CREATED');
          } else {
            const activity = `PowerSupply Edit - Supply#${this.supplyNumber} Save - Error`;
            const message = `PowerSupply Supply#${this.supplyNumber} Create Error. Data: ${JSON.stringify(jsonPowerSupplySfpTriage)}`;
            this.commonService.loggerPost(message, activity, 3);
            this.dialogRef.close('FAILED');
          }
        },
          err => {
            const activity = `PowerSupply Edit - Supply#${this.supplyNumber} Save - Error`;
            const message = `PowerSupply Supply#${this.supplyNumber} Create Error. Data: ${JSON.stringify(jsonPowerSupplySfpTriage)}`;
            this.commonService.loggerPost(message, activity, 3);
            this.dialogRef.close('FAILED');
            this.showProgressBar = false;
          });
      } else {
        jsonPowerSupplySfpTriage.id = this.id;
        this.powerSupplyService.updatePowerSupplySfpTriage(jsonPowerSupplySfpTriage).subscribe(res => {
          this.showProgressBar = false;
          if (res.success === true) {
            this.onChangeSfpMac(this.sfpsupplyFormGroup.value.sfpMac);
            const activity = `PowerSupply Edit - Supply#${this.supplyNumber} Save`;
            const message = `PowerSupply Supply#${this.supplyNumber} Update Success. Data: ${JSON.stringify(jsonPowerSupplySfpTriage)}`;
            this.commonService.loggerPost(message, activity, 3);
            this.dialogRef.close('UPDATED');
          } else {
            const activity = `PowerSupply Edit - Supply#${this.supplyNumber} Save - Error`;
            const message = `PowerSupply Supply#${this.supplyNumber} Update Error. Data: ${JSON.stringify(jsonPowerSupplySfpTriage)}`;
            this.commonService.loggerPost(message, activity, 3);
            this.dialogRef.close('FAILED');
          }
        },
          err => {
            const activity = `PowerSupply Edit - Supply#${this.supplyNumber} Save - Error`;
            const message = `PowerSupply Supply#${this.supplyNumber} Update Error. Data: ${JSON.stringify(jsonPowerSupplySfpTriage)}`;
            this.commonService.loggerPost(message, activity, 3);
            this.dialogRef.close('FAILED');
            this.showProgressBar = false;
          });
      }
    }
    }
  }



  openErrorDialog(message: string) {
    this.powerSupplyMoveErrorDialog = this.dialog.open(PowerSupplyMoveErrorDialog, {
      data: {
        message: message ? message : ''
      },
      disableClose: true
    });
  }
  cancel() {
    this.dialogRef.close('OK');
  }

  markAsTouched(formGroup: any): void {
    Object.keys(formGroup.controls).forEach((key: string) => {
      const abstractControl = formGroup.get(key);
      if (abstractControl instanceof FormGroup || abstractControl instanceof FormArray) {
        this.markAsTouched(abstractControl);
      } else {
        abstractControl.markAsTouched();
        abstractControl.markAsDirty();
      }
    })
  }


  scanSuccessHandler($event: any) {
    this.information = $event;
    console.log(this.information)
    this.scannerEnabled = !this.scannerEnabled;
    this.zoomFlag = false;
    this.onScannedData()
  }

  enableScanner() {
    if(this.scannerEnabled){
      this.zoomFlag = false;
      this.scannerEnabled = true;
      this.scannerEnabled = !this.scannerEnabled;
    }else{
      this.zoomFlag = true;
      this.scannerEnabled= true;
      this.scannerEnabled = this.scannerEnabled;
    }
  }

  onScannedData() {
    // let scannerDataSplit = this.information.split(';');
    // console.log(scannerDataSplit)
    // this.scanSerialNum = scannerDataSplit[0];
    // this.scansfpmac = scannerDataSplit[1];
    // let procscansfpmac = this.scansfpmac.split(':');
    // var output = '';
    // for(var i = 0; i < procscansfpmac[1].length; i++) {
    //   output += procscansfpmac[1].charAt(i);
    //   if(i % 2 == 1 && i > 0) {
    //     output += ':';
    //   }
    // }
    // this.processedsfpMac = output.substring(0, output.length - 1);
    // let serialNum = this.scanSerialNum.split(':')
    // this.sfpsupplyFormGroup.patchValue({
    //   sfpMac: this.processedsfpMac,
    //   serialNo: serialNum[1],
    // });

    let scannerDataSplit = this.information.split(';');
    this.scanSerialNum = scannerDataSplit[0];
    this.scansfpmac = scannerDataSplit[1];
    if(this.scanSerialNum.indexOf('SN') !== -1){
      this.scanSerialNum = scannerDataSplit[0].trim();
    }else{
      this.scanSerialNum = scannerDataSplit[1].trim();
    }
    if(this.scansfpmac.indexOf('MAC') !== -1){
      this.scansfpmac = scannerDataSplit[1].trim();
    }else{
      this.scansfpmac = scannerDataSplit[0].trim();
    }
    let procscansfpmac = this.scansfpmac.split(':');
    let serialNum = this.scanSerialNum.split(':')
    this.sfpsupplyFormGroup.patchValue({
      sfpMac:  procscansfpmac[1].trim().replace(/..\B/g, '$&:'),
      serialNo: serialNum[1].trim(),
    });

   }
 //while change in textbox
  onChangeSfpMac(processedsfpMac){
    this.sharedService.editpssupplysetDatadetailview(processedsfpMac);
  }

  zoomIn(){
    if(this.zoomLevel < 1.4){
      this.zoomLevel += 0.1;
      this.applyZoom();
    }
  }
  zoomOut(){
    if(this.zoomLevel > 1){
      this.zoomLevel -= 0.1;
      this.applyZoom();
    }
  }
  applyZoom(){
    const videoElement = document.getElementById('qr-reader') as HTMLVideoElement;
    if(videoElement){
      videoElement.style.transform = `scale(${this.zoomLevel})`

    }
  }
  
}



